import { createFileRoute } from "@tanstack/react-router";

import ChoosePlanPage from "./-components/ChoosePlanPage";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/choose-plan"
)({
  component: ChoosePlanPage,
});
